module.exports = __webpack_public_path__ + "static/img/img-2.dc29b8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/fundingnew_/detail/jolin/1/img-2.jpg
// module id = gbbd
// module chunks = 1